import { render, staticRenderFns } from "./TermsofServiceEn.vue?vue&type=template&id=2687aa72&scoped=true&"
import script from "./TermsofServiceEn.vue?vue&type=script&lang=js&"
export * from "./TermsofServiceEn.vue?vue&type=script&lang=js&"
import style0 from "./TermsofServiceEn.vue?vue&type=style&index=0&id=2687aa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687aa72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
